// Meta (Facebook) Pixel integration
// Pixel: SAM Pixel - Shopify
export const META_PIXEL_ID = '1731429841564167'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Inject the official Meta Pixel snippet and fire PageView.
 * Safe to call multiple times — it will only initialize once.
 * Wrapped in try/catch so a pixel failure never crashes the app.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  try {
    const w = window as any

    // Build the fbq stub queue (the loader pushes calls until fbevents.js is ready)
    const fbq: any = function (...args: any[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue.push(args)
      }
    }
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
    w.fbq = w.fbq || fbq
    w._fbq = w._fbq || fbq

    // Inject fbevents.js
    const existing = document.querySelector(
      'script[src="https://connect.facebook.net/en_US/fbevents.js"]',
    )
    if (!existing) {
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(script)
    }

    w.fbq('init', META_PIXEL_ID)
    w.fbq('track', 'PageView')

    // <noscript> fallback pixel so the event also fires when JS is disabled
    if (!document.getElementById('meta-pixel-noscript')) {
      const noscript = document.createElement('noscript')
      noscript.id = 'meta-pixel-noscript'
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" alt="" />`
      document.body.appendChild(noscript)
    }
  } catch (err) {
    // Silent fail — pixel must never break the app
    // eslint-disable-next-line no-console
    console.warn('[MetaPixel] init failed:', err)
  }
}

/**
 * Track a standard Meta event (PageView, Lead, InitiateCheckout, Purchase, etc).
 */
export function trackEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  try {
    const fbq = (window as any).fbq
    if (typeof fbq === 'function') {
      fbq('track', event, params)
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[MetaPixel] trackEvent failed:', err)
  }
}

/**
 * Track a custom event (anything not in Meta's standard event list).
 */
export function trackCustom(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  try {
    const fbq = (window as any).fbq
    if (typeof fbq === 'function') {
      fbq('trackCustom', event, params)
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[MetaPixel] trackCustom failed:', err)
  }
}

// Product/value constants used across CTAs
export const PRODUCT_VALUE = 14999
export const PRODUCT_CURRENCY = 'ARS'
export const PRODUCT_NAME =
  'Los superpoderes que hay en mí — Colección completa'
export const PRODUCT_ID = 'superpoderes-coleccion-completa'
